export var getIsVisible = function getIsVisible(element) {
  return !!element && !!element.offsetParent;
};